import React from 'react';

/** Features.jsx — beige-theme redesign. Drop-in replacement. Self-contained. */
const FEATURES = [
  { icon: '📞', tint: '#F6E7E1', title: 'AI Voice Agents', body: '24/7 inbound response via AI voice agent. Handles enquiries, bookings, and triage without human intervention.' },
  { icon: '🔄', tint: '#EAEDE2', title: 'Workflow Automation', body: 'End-to-end automation of approvals, notifications, data entry, and follow-up sequences. No manual handoffs.' },
  { icon: '📄', tint: '#F0EEE7', title: 'Document & Data Processing', body: 'Automated extraction, classification, and routing of documents, forms, and structured data.' },
  { icon: '📅', tint: '#EAEDE2', title: 'Scheduling & Booking', body: 'Automated appointment management integrated with existing calendar and CRM systems.' },
  { icon: '🔌', tint: '#EFEDE6', title: 'Systems Integration', body: 'API-level connection across platforms, databases, and third-party tools. Eliminates manual data transfer.' },
  { icon: '📊', tint: '#F6E7E1', title: 'Reporting & Analytics', body: 'Automated report generation with configurable delivery schedules and alert thresholds.' },
  { icon: '🔒', tint: '#F0EEE7', title: 'Data Security', body: 'All processes run in your environment. No third-party data sharing. No use of your data for AI training.' },
];

const Features = () => (
  <section id="features" className="cai-ft">
    <div className="cai-ft-inner">
      <div className="cai-ft-head">
        <h2 className="cai-ft-h2">Six capabilities. One managed deployment.</h2>
        <p className="cai-ft-sub">AI voice agents, workflow automation, document processing, systems integration, and reporting — all deployed and managed for your business.</p>
      </div>
      <div className="cai-ft-grid">
        {FEATURES.map((f) => (
          <div key={f.title} className="cai-ft-card">
            <div className="cai-ft-icon" style={{ background: f.tint }}>{f.icon}</div>
            <h3 className="cai-ft-card-title">{f.title}</h3>
            <p className="cai-ft-card-body">{f.body}</p>
          </div>
        ))}
      </div>
    </div>
    <style>{`
      .cai-ft { background: #ECEAE3; padding: 96px 40px 0; }
      .cai-ft-inner { max-width: 1200px; margin: 0 auto; }
      .cai-ft-head { text-align: center; max-width: 800px; margin: 0 auto 48px; }
      .cai-ft-h2 { font-size: 42px; font-weight: 800; letter-spacing: -0.025em; margin: 0; line-height: 1.1; color: #1A1A18; }
      .cai-ft-sub { font-size: 18px; line-height: 1.55; color: #5A564D; margin: 18px 0 0; }
      .cai-ft-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 22px; }
      .cai-ft-card { background: #fff; border-radius: 20px; padding: 30px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); }
      .cai-ft-icon { width: 52px; height: 52px; border-radius: 14px; display: flex; align-items: center; justify-content: center; font-size: 25px; margin-bottom: 18px; }
      .cai-ft-card-title { margin: 0 0 9px; font-size: 19px; font-weight: 700; letter-spacing: -0.01em; color: #1A1A18; }
      .cai-ft-card-body { margin: 0; font-size: 15px; line-height: 1.55; color: #5A564D; }
      @media (max-width: 900px) { .cai-ft-grid { grid-template-columns: 1fr; } .cai-ft { padding: 64px 22px 0; } .cai-ft-h2 { font-size: 32px; } }
    `}</style>
  </section>
);

export default Features;
